<template>
    <div class="pests">
        <div class="wx_box">
            <div class="wx_main">
                <div class="top">
                    <div class="wx_title">
                        <span>病虫害</span>
                    </div>
                </div>
                <div class="select_year">
                    <span class="label">选择年份:</span>
                    <el-date-picker v-model="year" type="year" format="yyyy" size="mini" value-format="yyyy"
                    	:picker-options="pickerOptions" placeholder="选择年" @change="changeYear">
                    </el-date-picker>
                </div>
				<div class="tabs">
					 <span :class="{'active':tabShowNum==2}" @click="tabShowNum = 2">虫害</span>
				    <span :class="{'active':tabShowNum==1}" @click="tabShowNum = 1">病害</span>
				   
				</div>
				<div class="tabs">
					<span :class="{'active':areaShowNum==item.id}" @click="clickArea(item.id)"
						v-for="(item,index) in area_list" :key="index">{{item.name}}</span>
				
				</div>
              
                <template  v-for="(item,index) in category_list" v-if="tabShowNum == item.id" >
					<div :key="index">
                    <div class="plant" :key="key" v-for="(val,key) in item.children" v-if="val.max_month!=''">
                        <div class="img_box">
                            <div class="big_img" @click="handlePreview(img[val.id])">
                                <div class="img_title">{{val.insect_pest_name}}</div>
                                <img :src="img[val.id]" alt="">
                            </div>
                            <div class="small_img">
                                <span class="fl">{{val.max_month}}</span>
                                <div class="fr">
                                    <img :class="{'active':imgShowNum1==val.id+k}" :src="v" alt="" @click="imgClick1(val.id,v),imgShowNum1 = k" v-for="(v,k) in val.images" :key="val.id+k">

                                </div>
                            </div>
                        </div>
                        <div class="bar_charts">
                            <wxEcharts :chartsData="chartsData1[index][key]" key="1"></wxEcharts>
                        </div>
                        <div class="bar_charts">
                            <wxEcharts :chartsData="chartsData2[index][key]" key="2"></wxEcharts>
                        </div>
                    </div>
                 
</div>
                </template>
               
            </div>
        </div>
		<el-dialog :visible.sync="dialogVisibles">
		  <img width="100%" :src="dialogVisibleimage" alt="">
		</el-dialog>
    </div>
</template>

<script>
	 import {getTaskInsectPestYearList,getPestData} from '@/api/pest';
	 import {
	 	getFarmInfo
	 } from '@/api/api'
    import wxEcharts from '@/components/LinePests';
    export default {
        name: "pests",
        data(){
            return{
				areaShowNum:0,
				area_list:[],
				category_list:[],
				year_list:[],
				pickerOptions: this.disabledDate(),
                year:new Date().getFullYear().toString(),
                tabShowNum:2,
                imgShowNum1:0,
                title1:'3.01',
				dialogVisibles:false,
				dialogVisibleimage:'',
                imgURL1:require('../../assets/images/growth/yepian.png'),
				img:[],
				chartsData1:[],
				chartsData2:[],
                /* chartsData1:{
                    title:'日期',
                    legendData:['今年发生情况'],
                    xAxisData:['3.01','3.21','4.05','4.24','5.01','6.05','6.24'],
                    yAxisName:'单位：mm',
                    highData:[5,6,10,20,25,22,18,]
                },
                chartsData2:{
                    title:'日期',
                    legendData:['去年发生情况'],
                    xAxisData:['3.01','3.21','4.05','4.24','5.01','6.05','6.24'],
                    yAxisName:'单位：mm',
                    myData:[3,4,5,6,1,10,12]
                }, */
            }
        },
		created() {
			
			
			
			getFarmInfo(this.$route.params.id).then(resp => {
			
			
				if(resp.farm.is_check==1){
					this.get_year_list();
				}else{
					this.$message.error("请先完善农事管理板块相关申请工作，才能开通此板块！")
					this.$router.push("/park/detail/"+this.$route.params.id)
				}
				})
		},
        methods:{
			handlePreview(url) {
				this.dialogVisibles = true
				this.dialogVisibleimage = url
			},
			get_pest_data(){
				getPestData(this.$route.params.id,this.areaShowNum,this.year).then(resp=>{
					
					     resp.forEach((item,index)=>{
							  this.img[item.id]=''
							  this.chartsData1[index]=[]
							  this.chartsData2[index]=[]
							 item.children.forEach((val,key)=>{
							//	console.log("ssss"+val.images.length)
								if(val.images.length>0) {
									console.log("dddaa")
									this.img[val.id]=val.images[0]
								}
								 //console.log(val)
								 if(val.max_month!=''){
									 console.log(val.thisyear.average)
									 console.log(val.thisyear.month)
									 this.chartsData1[index][key]={
                    title:'日期',
                    legendData:['今年发生情况'],
                    xAxisData:val.thisyear.month,
                    yAxisName:'单位：mm',
                    highData:val.thisyear.average
                }
				
									 this.chartsData2[index][key]={
                    title:'日期',
                    legendData:['去年发生情况'],
                    xAxisData:val.lastyear.month,
                    yAxisName:'单位：mm',
                    myData:val.lastyear.average
                }
								 }
							 })
						 })
					     this.category_list=resp
						 
				})			
				
			},
			get_year_list(){
				//console.log("dddddddd")
				getTaskInsectPestYearList(this.$route.params.id,this.year).then(resp=>{
					this.year_list=resp.year_list
				   this.area_list=resp.area_list
				   resp.area_list .forEach((item,index)=>{
					     if(index==0){
							 this.areaShowNum=item["id"]
						 }
				   })
					this.year_list.forEach((item,index)=>{
						if(item.year==new Date().getFullYear().toString()){
							this.year=new Date().getFullYear().toString()
							
						}
					})
					this.get_pest_data()
				})
			},
			changeYear() {
				console.log(this.year)
				this.get_year_list()
			},
			clickArea(val){
				this.areaShowNum=val
				this.get_pest_data()
			},
			disabledDate() {
				let that = this
				console.log(that.year_list)
				return {
					disabledDate(date) {						
					    let result=true
						that.year_list.forEach((item, index) => {
						 if (item["year"] == date.getFullYear()) {						 	
						 	result=false
						 } else {						 							 	
						 } 
						});
						return result						
					}
				}
			},
            imgClick1(id,url){
                this.img[id] = url
               // this.title1 = title
            },
        },
        components: {
            wxEcharts
        }
    }
</script>

<style lang="less">
    .pests{
        .wx_box{
            .wx_main{
                background:radial-gradient(rgba(19, 62, 173, 0.74),rgba(5, 18, 32, 0.47));
                background-size: cover;
                padding: 11px 70px 30px 17px;
                .top{
                    overflow: hidden;
                }
                .select_year{
                    margin-top: 25px;
                    display: flex;
                    align-items: center;
                    .label{
                        width: 80px;
                        font-size: 16px;
                        color: #91AFBA;
                    }
                    .el-date-editor{
                        width: 125px;
                    }
                    .el-input__inner{
                        width: 125px;
                        text-align: center;
                        font-size: 16px;
                        background-color:transparent;
                        border: 1px solid #5C7E9F;
                        color: #91AFBA;
                    }
                }
                .tabs{
                    display: flex;
                    margin-top: 20px;
                    span{
                        width: 150px;
                        height: 22px;
                        border: 1px solid #2B92F6;
                        line-height: 22px;
                        font-size: 14px;
                        color: #fff;
                        text-align: center;
                        cursor: pointer;
                    }
                    .active{
                        background: #2B92F6;
                        color: #fff;
                    }
                }
                .plant{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    border-bottom: 1px solid rgba(0, 161, 230, 0.2716);
                    padding-bottom: 46px;
                    padding-top: 40px;
                    &:last-child{
                        border-bottom: 0;
                    }
                    .img_box{
                        width: 444px;
                        height: 401px;
                        position: relative;
                        .img_title{
                            font-size: 18px;
                            font-weight: bold;
                            color: #FFFFFF;
                            padding-bottom: 18px;
                            text-align: center;
                        }
                        .big_img{
                            width: 444px;
                            height: 356px;
                            img{
                                width: 444px;
                                height: 356px;
                            }
                        }
                        .small_img{
                            width: 100%;
                            height: 40px;
                            position: absolute;
                            bottom: 0;
                            left: 0;
                            background-color: rgba(18, 18, 18, .6);
                            span{
                                font-size: 18px;
                                font-weight: 400;
                                color: #FFFFFF;
                                line-height: 40px;
                                padding-left: 24px;
                            }
                            div{
                                height: 100%;
                                display: flex;
                                align-items: center;
                                img{
                                    width: 44px;
                                    height: 30px;
                                    margin-right: 12px;
                                    cursor: pointer;
                                }
                                .active{
                                    border:1px solid #fff;
                                }
                            }
                        }
                    }
                    .echarts_box{width: 500px}
                    .my_table{
                        thead{
                            tr{
                                th{
                                    font-size: 16px;
                                }
                            }
                        }
                        tbody{
                            tr{
                                td{
                                    font-size: 16px;
                                    padding: 6px 0;
                                    img{
                                        width: 16px;
                                        height: 15px;
                                        margin-left: 5px;
                                    }
                                }
                            }
                        }
                    }
                }
                .bar_charts{
                    width: 580px;
                }
            }
        }
    }
</style>